import React from 'react';

import PageLayout from 'components/common/PageLayout';
import ScrollSection from 'components/common/ScrollSection';
import TopSection from 'components/common/TopSection';
import { SUBSCRIPTION_PLANS_PAGE } from 'components/constants';

import styles from './styles.module.scss';

const sections = [
  {
    title: 'Turn any URL into an engagement product.',
    desc:
      'Paste a URL and Storycards AI uses its content and visual direction to create a related interactive product.',
    videoSrc: {
      desktop: 'https://assts.stories.sc/website/desktop/ai_by_url.mp4',
      mobile: 'https://assts.stories.sc/website/mobile/ai_by_url.mp4',
    },
    poster: {
      desktop: 'https://assts.stories.sc/website/poster/ai_by_url.jpg',
    },
  },
  {
    title: 'Turn a prompt into a playable product.',
    desc:
      'Describe the topic and Storycards AI drafts the questions, visuals and logic for a quiz, poll, game or other engagement format.',
    videoSrc: {
      desktop: 'https://assts.stories.sc/website/desktop/aiplayful.mp4',
      mobile: 'https://assts.stories.sc/website/mobile/aiplayful.mp4',
    },
    poster: {
      desktop: 'https://assts.stories.sc/website/poster/aiplayful.jpg',
    },
  },
  {
    title: 'Learn what drives engagement.',
    desc:
      'Storycards AI analyzes responses, completion data and interaction patterns to identify what works and where each product can improve.',
    videoSrc: {
      desktop:
        'https://player.vimeo.com/progressive_redirect/playback/912106329/rendition/720p/file.mp4?loc=external&log_user=0&signature=854c7a80f1452fe55a6d39e7da9f9dd4d1cbe9e730aac6567ea21c71821c108d',
    },
  },
  {
    title: 'Turn your brand into the starting point.',
    desc:
      'Use your website as a design reference so each generated product follows its colors, typography and visual direction.',
    videoSrc: {
      desktop:
        'https://player.vimeo.com/progressive_redirect/playback/912108327/rendition/720p/file.mp4?loc=external&log_user=0&signature=73153747d24f63e610db99527da12dcf02873f37e018e8ab0ec331aec6999214',
    },
  },
];

const EngagementAI: React.FC = () => (
  <PageLayout className={styles.engagementAI} isFullWidth isWhiteHeader={false}>
    <TopSection
      title="The Storycards Engagement AI Engine."
      subtitle="Create engagement products from a URL or prompt, adapt them to your brand and use real behavior to improve performance."
      ctaLabel="Start Creating"
      ctaUrl={SUBSCRIPTION_PLANS_PAGE}
    />

    <main className={styles.content}>
      <section className={styles.introduction}>
        <div className={styles.videoWrapper}>
          <iframe
            className={styles.videoIframe}
            src="https://player.vimeo.com/video/1043051852?badge=0&autopause=0&player_id=0&app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            loading="lazy"
            title="Storycards Engagement AI Engine"
          />
        </div>
        <p>
          Storycards AI turns content and ideas into playable, data-driven products designed for participation.
        </p>
      </section>

      <div className={styles.scrollSectionWrapper}>
        <ScrollSection sectionData={sections} headingLevel="h2" />
      </div>
    </main>
  </PageLayout>
);

export default EngagementAI;
